import Image from "next/image";
import {Button} from "@/components/base/Buttons";
import styled from "styled-components";
import {breakpoints} from "@/styles/sizes";
import {DangerousDescriptionWrapper} from "@/styles/GlobalStyles";

const ContentWrapper = styled.div`
  margin-top: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 30px;
    @media only screen and (${breakpoints.mobile}) {
        flex-direction: column;
        gap: 60px;
    }
`;


export default function StaticPageCardsSection({cards,description}) {
    return <div className={'container_small'}>
        <ContentWrapper>
            {
                cards?.map((item, index) => {
                    return <div
                        key={index}
                        style={{
                            textAlign: 'center',
                            maxWidth: '350px',
                        }}
                    >
                        <Image
                            width={300}
                            height={300}
                            src={item?.image?.url}
                            alt={item?.image?.alt ?? item?.image?.name}
                            style={{
                                width: '100%',
                                height: '300px',
                                objectFit: 'cover',
                            }}
                        />
                        <h3 className="h4" style={{marginTop:'20px'}}>{item?.title}</h3>
                        <p style={{marginBottom: '20px'}}>{item?.description}</p>

                        {item?.buttonText && <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}>
                            <Button variant={'green'} target="_blank" href={item?.buttonLink}>{item?.buttonText}</Button>
                        </div>}

                    </div>
                })
            }
        </ContentWrapper>
    </div>
}
